(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[182],{

/***/ 8892:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function BriefcaseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
  }));
}

const ForwardRef = React.forwardRef(BriefcaseIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 6741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function MapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"
  }));
}

const ForwardRef = React.forwardRef(MapIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/mencia-de-mendoza-lyceum",
      function () {
        return __webpack_require__(6760);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4928:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/gebouw.2170bc46.jpg","height":3334,"width":5000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAcEAABBAMBAAAAAAAAAAAAAAABAAMEBQIREjH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAQD/2gAMAwEAAhEDEQA/AIUNrLq4jbkRznsDoZjYO/UREQSN/9k=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ian.38f0c3aa.jpg","height":4242,"width":3507,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAdEAACAQQDAAAAAAAAAAAAAAABAwACBBEhEhPh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQT/xAAZEQACAwEAAAAAAAAAAAAAAAAAAQIDEXH/2gAMAwEAAhEDEQA/AJp2MqtyopWF0HmGAjO9Y8iIjFk9izOH/9k=","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 758:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/app.fb4e806b.png","height":1008,"width":2120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAD1BMVEX9/f35+frz9PXp6uzR0tYpJC/lAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIUlEQVR4nB3IwREAMAiAMED3n7lnfwQmLaEG8Gq/se3WAwNQACsU3pZvAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 2605:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/email.b92485c1.png","height":1541,"width":1146,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAGFBMVEX09fj+/v/6+vrv8PLN4vCZxOHb6/W01estfp6NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nBXKwREAMAiEQDg19t9xxg8fFkoVqkACxEsi9kyLb/cdyb0j+gEIuABXoFJD3AAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 4973:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/milou.e4fa879a.jpg","height":3336,"width":2866,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAACAgMAAwAAAAAAAAAAAAABAgADBAUREiGR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgT/xAAaEQACAgMAAAAAAAAAAAAAAAABAgADBBEh/9oADAMBAAIRAxEAPwC3T5mTZuUpW1rLbC/mGcnqgdHz0IiIMdAybMouchuT/9k=","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 2106:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/newman.aaf87862.jpg","height":865,"width":1600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAACAQMFAAAAAAAAAAAAAAABAgADETEEBQYSIf/EABUBAQEAAAAAAAAAAAAAAAAAAAQF/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAhMf/aAAwDAQACEQMRAD8AlRzPeBpqpZqDs46ljSFwPcWxERKhvYqBf//Z","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 6055:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/newman2.f09055f6.jpg","height":1200,"width":1600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABBAEFAAAAAAAAAAAAAAAAAQIEERIFEyEy0f/EABUBAQEAAAAAAAAAAAAAAAAAAAAD/8QAGhEAAgIDAAAAAAAAAAAAAAAAAQIAAxEhQf/aAAwDAQACEQMRAD8AsdIkNvWVwVmdbfPbwAFqHbDb6YuUZGuCf//Z","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 8391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ TextArea; },
/* harmony export */   "nv": function() { return /* binding */ TextField; }
/* harmony export */ });
/* unused harmony export SelectField */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);


const formClasses = "block w-full appearance-none rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm";
function Label(param) {
    let { id , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        htmlFor: id,
        className: "mb-3 block text-sm font-medium text-gray-700",
        children: children
    });
}
function TextField(param) {
    let { id , label , type ="text" , className ="" , register , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                id: id,
                type: type,
                ...register,
                ...props,
                className: formClasses
            })
        ]
    });
}
function TextArea(param) {
    let { id , label , className ="" , register , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                id: id,
                ...register,
                ...props,
                className: formClasses
            })
        ]
    });
}
function SelectField(param) {
    let { id , label , className ="" , ...props } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ _jsx(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ _jsx("select", {
                id: id,
                ...props,
                className: clsx(formClasses, "pr-8")
            })
        ]
    });
}


/***/ }),

/***/ 3172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Office; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/MapIcon.js
var MapIcon = __webpack_require__(6741);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/BriefcaseIcon.js
var BriefcaseIcon = __webpack_require__(8892);
// EXTERNAL MODULE: ./src/components/Fields.jsx
var Fields = __webpack_require__(8391);
// EXTERNAL MODULE: ./src/components/Button.jsx
var Button = __webpack_require__(1109);
;// CONCATENATED MODULE: ./src/images/office.jpg
/* harmony default export */ var office = ({"src":"/_next/static/media/office.81684f07.jpg","height":1733,"width":2600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAcEAACAgMBAQAAAAAAAAAAAAABAgADBAUREiH/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAECQf/aAAwDAQACEQMRAD8AiwNLiPubFepHbHYVrY3oseAnpPfpiIgSFWH/2Q==","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Office.jsx






function Office() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:absolute lg:inset-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "h-56 w-full object-cover lg:absolute lg:h-full",
                        src: office,
                        alt: "Kantoor"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative py-16 px-6 sm:py-24 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:px-8 lg:py-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:pr-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-md sm:max-w-lg lg:mx-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-2xl font-bold text-gray-900 sm:text-3xl sm:tracking-tight font-display",
                                    children: "Bedrijfsgegevens"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-lg text-gray-500",
                                        children: "Graag een keer langskomen? Wij zijn gevestigd in 's-Hertogenbosch."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-9",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-shrink-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapIcon, {
                                                        className: "h-6 w-6 text-gray-400",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ml-3 text-base text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "font-semibold",
                                                            children: "The Lobby"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-1",
                                                            children: "Reitscheweg 1"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-1",
                                                            children: "'s-Hertogenbosch"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-1",
                                                            children: "5232 BX"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6 flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex-shrink-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BriefcaseIcon, {
                                                        className: "h-6 w-6 text-gray-400",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ml-3 text-base text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "KVK: 87979284"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-1",
                                                            children: "BTW: NL864465695B01"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 6760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MenciaDeMendozaLyceum; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7027);
/* harmony import */ var _components_HeaderSimple__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2055);
/* harmony import */ var _components_Team__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7947);
/* harmony import */ var _components_Office__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3172);
/* harmony import */ var _components_CallToAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4778);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3862);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _images_cases_newman_milou_jpg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4973);
/* harmony import */ var _images_cases_newman_newman_jpg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2106);
/* harmony import */ var _images_cases_newman_newman2_jpg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6055);
/* harmony import */ var _images_cases_newman_email_png__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2605);
/* harmony import */ var _images_cases_newman_app_png__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(758);
/* harmony import */ var _images_cases_mencia_gebouw_jpg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4928);
/* harmony import */ var _images_cases_mencia_ian_jpg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6612);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_16__);

















function MenciaDeMendozaLyceum() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: "Interview Ian Lammerse, Mencia de Mendoza Lyceum in Breda",
                description: "Het Mencia de Mendoza Lyceum maakt voor het faciliteren van bijles tussen leerlingen onderling gebruik van het platform Bijlesplein. En met succes."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_2__/* .Header */ .h, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white px-6 py-10 lg:py-24 lg:px-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mx-auto max-w-6xl text-base leading-7 text-gray-700 grid grid-cols-1 lg:grid-cols-2 gap-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-base font-semibold leading-7 text-blue-600",
                                                children: "Interview Ian Lammerse, Mencia de Mendoza Lyceum in Breda"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                                                children: "“Dit is een compleet plaatje als het gaat om vraag en aanbod van bijles tussen leerlingen onderling”"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mt-6 text-lg leading-8",
                                                children: "Ian Lammerse is onderwijsassistent en leerlingbegeleider op het Mencia de Mendoza Lyceum in Breda. Het Mencia is sinds begin 2023 gebruiker van Bijlesplein. Ian is de contactpersoon voor het platform en wij interviewden hem over de ervaringen met Bijlesplein. “Voorheen werkten we met Excellijsten. Het organiseren van bijles ging als volgt: een leerling gaf bij de vakdocent of mentor aan dat hij of zij op zoek was naar bijles. De docent/mentor pakte de Excellijst erbij en zorgde voor de verbinding tussen de lentor (tutor) en de leerling die bijles wilde krijgen. Dat vroeg best veel werk van de docent. Met Bijlesplein maken leerlingen nu zelf de verbinding en we zien dat dat goed werkt.”"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "relative mx-auto max-w-prose text-base lg:max-w-none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "aspect-h-12 aspect-w-12 lg:aspect-none",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                            className: "rounded-lg object-cover object-center shadow-lg",
                                                            src: _images_cases_mencia_ian_jpg__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z,
                                                            alt: "Foto van Ian Lammerse"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                        className: "mt-3 flex text-sm text-gray-500",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                className: "h-5 w-5 flex-none text-gray-400",
                                                                viewBox: "0 0 20 20",
                                                                fill: "currentColor",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    d: "M1 8a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 018.07 3h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0016.07 6H17a2 2 0 012 2v7a2 2 0 01-2 2H3a2 2 0 01-2-2V8zm13.5 3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM10 14a3 3 0 100-6 3 3 0 000 6z",
                                                                    clipRule: "evenodd"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "ml-2",
                                                                children: "Foto van Ian Lammerse"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto max-w-3xl text-base leading-7 text-gray-700",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-10 max-w-2xl",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: true,
                                            children: "Het Mencia de Mendoza Lyceum heeft altijd gewerkt met lentoren, leerlingen die elkaar lesgeven. “Het gebeurt wel eens dat docenten dat zelf doen, bijvoorbeeld het uitleggen van een bepaalde opdracht of onderwerp. Maar de echte bijles wordt voornamelijk door leerlingen zelf gedaan.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "Door gebruik te maken van lentoren kun je op een laagdrempelige manier bijles organiseren. En het is bewezen effectief. “Bijlesplein helpt ons omdat het heel makkelijk wordt gemaakt om contact tussen leerlingen onderling te leggen. Vraag en aanbod komen samen.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Door leerlingen elkaar bijles te laten geven hoeven leerlingen die bijles nodig hebben niet de stap naar een dure bijlespartij te maken. Op deze manier kunnen we de kansenongelijkheid op financieel vlak zo laag mogelijk houden. Leerlingen hebben bij ons zelf in de hand wat ze voor een bijles vragen. Dat kan €5, €7,50 of €10 per uur zijn.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Als school weten we lang niet altijd hoe de situatie thuis is. Ik merk dat zeker leerlingen in de bovenbouw een volwassen insteek hebben. Zij hebben vaak een eigen bijbaantje en betalen daarmee de bijles zelf. Wanneer zij commerci\xeble partijen moeten gaan betalen, is dat bijna niet haalbaar. De drempel wordt nu een stuk lager gemaakt voor leerlingen.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Door het portal Bijlesplein bieden wij als school een hele makkelijke service aan leerlingen. Zij hebben zelf in de hand om de stap naar bijles te zetten om bijvoorbeeld toch over te gaan of een examen te halen. Een gesprek met een docent of mentor is in sommige gevallen minder uitnodigend. En we zien dat het werkt. Je ziet gebeuren dat leerlingen volledig op eigen initiatief die bijles regelen.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                            className: "mt-16",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                    className: "aspect-video rounded-xl bg-gray-50 object-cover",
                                                    src: _images_cases_mencia_gebouw_jpg__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,
                                                    alt: "Het Mencia de Mendoza Lyceum"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                                    className: "mt-4 flex gap-x-2 text-sm leading-6 text-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            className: "mt-0.5 h-5 w-5 flex-none text-gray-300",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
                                                                clipRule: "evenodd"
                                                            })
                                                        }),
                                                        "Het Mencia de Mendoza Lyceum"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Hoe verloopt de samenwerking met Bijlesplein?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-6",
                                            children: "De samenwerking tussen het Mencia en Bijlesplein is gestart met Wouter Jagers, de TTO-afdelingsleider en met Rob van Gils samen. “We zijn vorig kalenderjaar gestart en hebben met de bestaande lentoren een test gedaan met Bijlesplein. Vanaf het moment dat de site voor ons klaar was gemaakt om te gaan gebruiken, ben ik de contactpersoon geworden voor alles wat met Bijlesplein te maken heeft. Collega’s en leerlingen weten mij te vinden als het gaat over de portal.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“De basis om Bijlesplein te gaan gebruiken is enerzijds het goede contact en het vertrouwen in elkaar. Daarnaast is onze school overtuigd van de werking van het platform. Er zitten veel voordelen aan. De drempel ligt lager voor leerlingen om bijles te zoeken of aan te bieden. Ze hebben het in eigen hand en we zien dat het werkt.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Het is heel gebruiksvriendelijk waardoor leerlingen via hun eigen laptop of mobiel zich makkelijk kunnen aanmelden en een match kunnen zoeken. En het gaat veel sneller. In plaats van dat je naar de mentor moet stappen, die moet in een bestandje duiken en de leerling moet wachten op een match. Het is nu veel sneller geregeld. En een mentor heeft het druk genoeg. Bijlesplein legt de pro activiteit bij een leerling neer. Wanneer zijzelf de stappen nemen en zelf snel reageren, kunnen ze bij wijze van dezelfde dag nog aan de slag zijn. Dat gaat sneller dan met het Excelbestand via de mentor of docent.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“In het begin verliep het inloggen niet helemaal soepel. Het is gekoppeld aan Magister. Leerlingen die dan met een ander mailadres probeerde in te loggen kregen geen verificatiemail. Samen met Bijlesplein komen we altijd snel tot een oplossing. Het is heel persoonlijk en vaak snel opgelost. Ook bij nieuwe idee\xebn trouwens.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Complete plaatje"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-8",
                                            children: "“Ik zou Bijlesplein zeker aanraden aan andere scholen. De voordelen heb ik eerder al genoemd. Het maakt het makkelijk voor leerlingen \xe9n de school en het is een goedkopere oplossing om bijles aan te kunnen bieden. Leerlingen hebben het in eigen hand en de school hoeft minder tijd te besteden aan de organisatie ervan. Wat mij betreft is dit een compleet plaatje als het gaat om vraag en aanbod van bijles tussen leerlingen onderling.”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "mt-16 text-2xl font-bold tracking-tight text-gray-900",
                                            children: "Ook benieuwd naar de mogelijkheden van Bijlesplein voor jouw school?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "mt-8",
                                            children: [
                                                "Neem ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_16___default()), {
                                                    href: "/contact",
                                                    children: "contact"
                                                }),
                                                " met ons op of vraag direct een ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_16___default()), {
                                                    href: "/demo",
                                                    children: "gratis demo"
                                                }),
                                                " aan."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CallToAction__WEBPACK_IMPORTED_MODULE_6__/* .CallToAction */ .J, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_7__/* .Footer */ .$, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [695,597,247,774,888,179], function() { return __webpack_exec__(5231); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);